const stores = {} // by se id

const init = (instance) => {
    if (stores[instance.options.engineId]) {
        return stores[instance.options.engineId]
    }

    stores[instance.options.engineId] = {
        countries: [],
        domaines: [],
        departments: [],
        parentStations: [],
        regions: [],
        stations: []
    }

    return stores[instance.options.engineId]
}

export default init
